import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import stl from "./OtpLimitExceeded.module.css";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
var OtpLimitExceeded = function OtpLimitExceeded(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.wrapper, " ").concat(className ? className : "")
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/time-bomb.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("strong", null, t("try_again_24_hours", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", null, t("exceeded_number_verification_code_attempts", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    type: "button",
    onClick: onClick
  }, t("back_homepge", {
    ns: "web_common"
  })));
};
export default OtpLimitExceeded;